import { render, staticRenderFns } from "./UserRoleManagementDialog.vue?vue&type=template&id=d4c1b78a&scoped=true&"
import script from "./UserRoleManagementDialog.vue?vue&type=script&lang=js&"
export * from "./UserRoleManagementDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleManagementDialog.vue?vue&type=style&index=0&id=d4c1b78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c1b78a",
  null
  
)

export default component.exports